<div class="flex items-center gap-1">
  <p-select
    scrollHeight="400px"
    [options]="filterOptions()"
    placeholder="Filter..."
    [showClear]="showClear() && (filter() !== null) && (filter() !== undefined && filter() != '')"
    [(ngModel)]="filter"
    appendTo="body"
    class="font-normal"
    size="small"
  >
    <ng-template #item let-option>
      @if(option.icon) {
        <i class="fa-solid {{ option.icon }} {{ option.colorClass }} mr-1"></i>
      }
      {{ option.label }}
    </ng-template>
  </p-select>
</div>
